<!-- ALLORA INTEGRATION -->
<div class="flex-1 flex flex-col h-full overflow-hidden bg-slate-100">

    <!-- ================= LISTA (HOME) ================= -->
    <ng-container *ngIf="!detailRun()">

        <!-- HEADER -->
        <header class="bg-white border-b border-slate-200 px-8 py-5 flex items-center justify-between shrink-0">
            <div class="flex items-center gap-4">
                <div
                    class="w-11 h-11 rounded-xl bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center text-white shadow-lg shadow-orange-500/20">
                    <lucide-icon [img]="icons.Factory" class="w-5 h-5"></lucide-icon>
                </div>
                <div>
                    <h1 class="text-lg font-bold text-slate-800">Integração Allora</h1>
                    <p class="text-xs text-slate-500">Protheus → Allora</p>
                </div>
            </div>
            <div class="flex items-center gap-3">
                <!-- Indicador de auto-atualização (só no histórico) -->
                <div *ngIf="activeView() === 'history'"
                    class="hidden md:flex items-center gap-1.5 text-[11px] text-slate-400">
                    <span class="relative flex h-2 w-2">
                        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                    </span>
                    <span *ngIf="lastRefreshedAt()">
                        Atualizado às {{ lastRefreshedAt()! | date:'HH:mm:ss' }}
                    </span>
                </div>

                <!-- Alterações pendentes na config -->
                <div *ngIf="activeView() === 'config' && hasPendingChanges()"
                    class="hidden md:flex items-center gap-1.5 text-[11px] font-semibold text-amber-600 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-lg">
                    <lucide-icon [img]="icons.AlertTriangle" class="w-3 h-3"></lucide-icon>
                    {{ configDrafts().size }} alteração(ões) não salva(s)
                </div>

                <!-- Botão Atualizar (só no histórico) -->
                <button *ngIf="activeView() === 'history'"
                    (click)="refreshHistory()" [disabled]="historyLoading()"
                    title="Atualizar lista"
                    class="flex items-center gap-1.5 px-3.5 py-2 rounded-xl font-bold text-sm border border-slate-200 text-slate-600 hover:bg-slate-100 transition-all disabled:opacity-40 disabled:cursor-not-allowed">
                    <lucide-icon [img]="icons.RefreshCw"
                        [class]="'w-4 h-4' + (historyLoading() ? ' animate-spin' : '')"></lucide-icon>
                    <span class="hidden md:inline">Atualizar</span>
                </button>

                <!-- Toggle de view: Histórico / Configurações (Admin only) -->
                <div *ngIf="canAdmin()"
                    class="flex items-center bg-slate-100 rounded-xl p-1 gap-1">
                    <button (click)="activeView.set('history')"
                        [class]="'flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all ' +
                            (activeView() === 'history' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700')">
                        <lucide-icon [img]="icons.Database" class="w-3.5 h-3.5"></lucide-icon>
                        Histórico
                    </button>
                    <button (click)="activeView.set('config')"
                        [class]="'flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all ' +
                            (activeView() === 'config' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700')">
                        <lucide-icon [img]="icons.Settings" class="w-3.5 h-3.5"></lucide-icon>
                        Configurações
                    </button>
                </div>

                <!-- Botão Nova Integração (só no histórico) -->
                <button *ngIf="activeView() === 'history'"
                    (click)="openModal()" [disabled]="!canTrigger() || service.isRunning()"
                    [title]="!canTrigger() ? 'Seu perfil permite apenas visualização' : service.isRunning() ? 'Já existe uma integração em andamento' : 'Iniciar nova integração'"
                    class="flex items-center gap-2 px-5 py-2.5 rounded-xl font-bold text-sm transition-all shadow-lg bg-gradient-to-r from-orange-500 to-red-600 text-white shadow-orange-500/25 hover:from-orange-600 hover:to-red-700 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:active:scale-100">
                    <lucide-icon [img]="icons.Zap" class="w-4 h-4"></lucide-icon>
                    NOVA INTEGRAÇÃO
                </button>
            </div>
        </header>

        <!-- ================= CONFIG VIEW ================= -->
        <div *ngIf="activeView() === 'config'" class="flex-1 overflow-y-auto p-8">
            <div class="max-w-5xl mx-auto flex flex-col gap-6">
                <div>
                    <h2 class="text-base font-bold text-slate-800 flex items-center gap-2">
                        <lucide-icon [img]="icons.Layers" class="w-4 h-4 text-orange-500"></lucide-icon>
                        Configuração de Job Types
                    </h2>
                    <p class="text-xs text-slate-500 mt-0.5">
                        Ajuste nome de exibição, categoria, tamanho do lote e ative ou desative cada tipo de job.
                        As alterações só são enviadas ao servidor ao clicar em <strong>Salvar</strong>.
                    </p>
                </div>

                <!-- Skeleton -->
                <!-- Erro de carregamento -->
                <div *ngIf="allJobTypesError()"
                    class="bg-red-50 border border-red-200 rounded-xl px-4 py-3 flex items-center gap-2 text-sm text-red-700">
                    <lucide-icon [img]="icons.AlertTriangle" class="w-4 h-4 shrink-0"></lucide-icon>
                    {{ allJobTypesError() }}
                </div>

                <div *ngIf="allJobTypesLoading()" class="flex flex-col gap-3">
                    <div *ngFor="let i of [0,1,2,3]"
                        class="bg-white rounded-xl border border-slate-200 p-4 animate-pulse flex gap-4">
                        <div class="h-4 bg-slate-100 rounded w-8"></div>
                        <div class="h-4 bg-slate-100 rounded w-1/4"></div>
                        <div class="h-4 bg-slate-100 rounded flex-1"></div>
                        <div class="h-4 bg-slate-100 rounded w-28"></div>
                        <div class="h-4 bg-slate-100 rounded w-20"></div>
                    </div>
                </div>

                <!-- Job types agrupados -->
                <ng-container *ngIf="!allJobTypesLoading() && !allJobTypesError()">
                    <div *ngFor="let group of allJobTypeGroups()" class="flex flex-col gap-2">
                        <div class="flex items-center gap-2 mb-1">
                            <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ group.name }}</span>
                            <div class="flex-1 h-px bg-slate-200"></div>
                        </div>
                        <div *ngFor="let jt of group.items; trackBy: trackJobType.bind(this)"
                            [class]="'bg-white rounded-xl border transition-all ' + (isDirty(jt) ? 'border-amber-300 shadow-sm shadow-amber-100' : 'border-slate-200')">
                            <div class="px-5 py-4 flex items-center gap-4">
                                <!-- Toggle ativo/inativo -->
                                <button (click)="patchDraft(jt, { enabled: !getDraft(jt).enabled })"
                                    [title]="getDraft(jt).enabled ? 'Desativar' : 'Ativar'"
                                    class="shrink-0 transition-all active:scale-90">
                                    @if (getDraft(jt).enabled) {
                                        <lucide-icon [img]="icons.ToggleRight" class="w-8 h-8 text-emerald-500"></lucide-icon>
                                    } @else {
                                        <lucide-icon [img]="icons.ToggleLeft" class="w-8 h-8 text-slate-300"></lucide-icon>
                                    }
                                </button>
                                <!-- Nome interno -->
                                <div class="w-36 shrink-0">
                                    <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wide mb-0.5">Nome interno</p>
                                    <p class="text-xs font-mono text-slate-500 truncate" [title]="jt.name">{{ jt.name }}</p>
                                </div>
                                <!-- Display Name -->
                                <div class="flex-1 min-w-0">
                                    <label class="text-[10px] font-bold text-slate-400 uppercase tracking-wide block mb-0.5">Nome de exibição</label>
                                    <input type="text" [value]="getDraft(jt).displayName"
                                        (input)="patchDraft(jt, { displayName: $any($event.target).value })"
                                        class="w-full px-2.5 py-1.5 rounded-lg border border-slate-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-xs font-semibold text-slate-700 bg-slate-50 focus:bg-white" />
                                </div>
                                <!-- Categoria -->
                                <div class="w-44 shrink-0">
                                    <label class="text-[10px] font-bold text-slate-400 uppercase tracking-wide block mb-0.5">Categoria</label>
                                    <input type="text" [value]="getDraft(jt).category"
                                        (input)="patchDraft(jt, { category: $any($event.target).value })"
                                        class="w-full px-2.5 py-1.5 rounded-lg border border-slate-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-xs text-slate-700 bg-slate-50 focus:bg-white" />
                                </div>
                                <!-- Batch Size -->
                                <div class="w-32 shrink-0">
                                    <label class="text-[10px] font-bold text-slate-400 uppercase tracking-wide block mb-0.5">Tamanho do lote</label>
                                    <div class="relative">
                                        <lucide-icon [img]="icons.Layers" class="w-3 h-3 text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none"></lucide-icon>
                                        <input type="number" min="1" max="10000" [value]="getDraft(jt).batchSize"
                                            (input)="patchDraft(jt, { batchSize: +$any($event.target).value })"
                                            class="w-full pl-9 pr-2.5 py-1.5 rounded-lg border border-slate-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-xs text-slate-700 bg-slate-50 focus:bg-white" />
                                    </div>
                                </div>
                                <!-- Ações -->
                                <div class="flex items-center gap-1.5 shrink-0">
                                    <button *ngIf="isDirty(jt)" (click)="discardDraft(jt)" title="Descartar"
                                        class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all">
                                        <lucide-icon [img]="icons.X" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                    <button (click)="saveConfig(jt)" [disabled]="!isDirty(jt) || isSaving(jt)"
                                        [class]="'flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-bold transition-all ' +
                                            (isDirty(jt) && !isSaving(jt) ? 'bg-orange-500 text-white hover:bg-orange-600 shadow-sm active:scale-95' : 'bg-slate-100 text-slate-400 cursor-not-allowed')">
                                        @if (isSaving(jt)) {
                                            <lucide-icon [img]="icons.Loader" class="w-3.5 h-3.5 animate-spin"></lucide-icon>
                                            Salvando
                                        } @else {
                                            <lucide-icon [img]="icons.Save" class="w-3.5 h-3.5"></lucide-icon>
                                            Salvar
                                        }
                                    </button>
                                </div>
                            </div>
                            <!-- Indicador dirty -->
                            <div *ngIf="isDirty(jt)" class="px-5 pb-3 flex items-center gap-1.5 text-[10px] text-amber-600 font-semibold">
                                <lucide-icon [img]="icons.AlertTriangle" class="w-3 h-3"></lucide-icon>
                                Alterações não salvas
                            </div>
                        </div>
                    </div>
                    <!-- Empty state -->
                    <div *ngIf="allJobTypeGroups().length === 0"
                        class="bg-white rounded-xl border border-slate-200 p-12 flex flex-col items-center gap-3 text-center">
                        <lucide-icon [img]="icons.Settings" class="w-8 h-8 text-slate-300"></lucide-icon>
                        <p class="text-sm font-semibold text-slate-500">Nenhum job type encontrado.</p>
                        <p class="text-xs text-slate-400">Os job types são carregados automaticamente da API.</p>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- ================= HISTORY VIEW ================= -->
        <div *ngIf="activeView() === 'history'" class="flex-1 overflow-y-auto p-8">
            <div class="max-w-5xl mx-auto flex flex-col gap-8">

                <!-- INDICADORES: última integração com sucesso por entidade -->
                <section>
                    <h2 class="text-xs font-black text-slate-500 uppercase tracking-widest mb-3">Últimas integrações</h2>

                    <!-- Skeleton enquanto carrega -->
                    <div *ngIf="historyLoading() && lastSuccessCards().length === 0"
                        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                        <div *ngFor="let i of [0,1,2,3,4]"
                            class="bg-white rounded-xl border border-slate-200 p-3.5 shadow-sm animate-pulse">
                            <div class="h-4 bg-slate-100 rounded mb-2 w-3/4"></div>
                            <div class="h-3 bg-slate-100 rounded w-1/2"></div>
                        </div>
                    </div>

                    <div *ngIf="lastSuccessCards().length > 0"
                        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                        <div *ngFor="let card of lastSuccessCards(); trackBy: trackCard.bind(this)"
                            class="bg-white rounded-xl border border-slate-200 p-3.5 shadow-sm">
                            <div class="flex items-center gap-2 mb-2">
                                <lucide-icon [img]="card.lastSuccess ? icons.CheckCircle : icons.Clock"
                                    class="w-4 h-4 shrink-0"
                                    [ngClass]="card.lastSuccess ? 'text-emerald-500' : 'text-slate-300'"></lucide-icon>
                                <p class="text-xs font-bold text-slate-700 truncate" [title]="card.label">{{
                                    card.label }}</p>
                            </div>
                            <p *ngIf="card.lastSuccess" class="text-[11px] text-slate-500"
                                [title]="card.lastSuccess | date:'dd/MM/yyyy HH:mm:ss'">
                                {{ timeAgo(card.lastSuccess) }}</p>
                            <p *ngIf="!card.lastSuccess" class="text-[11px] text-slate-300 italic">nunca integrado</p>
                        </div>
                    </div>
                </section>

                <!-- LISTA DE INTEGRAÇÕES -->
                <section>
                    <h2 class="text-xs font-black text-slate-500 uppercase tracking-widest mb-3">Integrações</h2>

                    <!-- Estado: carregando -->
                    <div *ngIf="historyLoading() && runList().length === 0"
                        class="flex flex-col items-center justify-center py-16 gap-3">
                        <lucide-icon [img]="icons.Loader" class="w-8 h-8 text-orange-500 animate-spin"></lucide-icon>
                        <p class="text-sm text-slate-500 font-medium">Carregando integrações...</p>
                    </div>

                    <!-- Estado: erro -->
                    <div *ngIf="historyError() && !historyLoading()"
                        class="flex flex-col items-center justify-center py-16 gap-4">
                        <div class="w-12 h-12 rounded-full bg-red-50 border border-red-200 flex items-center justify-center">
                            <lucide-icon [img]="icons.AlertTriangle" class="w-6 h-6 text-red-500"></lucide-icon>
                        </div>
                        <p class="text-sm text-slate-600">{{ historyError() }}</p>
                        <button (click)="refreshHistory()"
                            class="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-bold border border-slate-200 text-slate-600 hover:bg-slate-100 transition-all">
                            <lucide-icon [img]="icons.RefreshCw" class="w-3.5 h-3.5"></lucide-icon>
                            Tentar novamente
                        </button>
                    </div>

                    <!-- Estado: vazio -->
                    <div *ngIf="!historyLoading() && !historyError() && runList().length === 0"
                        class="flex flex-col items-center justify-center py-16 gap-3 text-slate-400">
                        <lucide-icon [img]="icons.Clock" class="w-8 h-8 text-slate-200"></lucide-icon>
                        <p class="text-sm">Nenhuma integração encontrada.</p>
                    </div>

                    <div class="flex flex-col gap-3" *ngIf="runList().length > 0">
                        <div *ngFor="let run of runList(); trackBy: trackRun.bind(this)"
                            class="bg-white rounded-2xl border border-slate-200 shadow-sm px-6 py-4 flex flex-col gap-3"
                            [class.ring-2]="run.status === 'RUNNING'"
                            [class.ring-indigo-200]="run.status === 'RUNNING'">

                            <div class="flex flex-wrap items-center justify-between gap-3">
                                <div class="flex items-center gap-3">
                                    <span class="font-mono text-sm font-bold text-slate-800">{{ run.id }}</span>
                                    <span class="text-[11px] px-2.5 py-0.5 rounded-full border font-semibold"
                                        [ngClass]="runBadgeClass(run.status)">
                                        {{ runStatusLabel(run.status) }}
                                    </span>
                                    <span *ngIf="run.status === 'RUNNING'"
                                        class="text-[10px] font-bold text-white bg-red-500 px-2 py-0.5 rounded-full uppercase tracking-wider animate-pulse">ao
                                        vivo</span>
                                </div>
                                <div class="flex items-center gap-4 text-xs text-slate-500">
                                    <span>{{ run.startedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                    <span class="hidden md:inline">{{ run.triggeredBy }}</span>
                                    <button (click)="openDetail(run)"
                                        class="flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-xs font-bold border border-slate-200 text-slate-600 hover:bg-slate-800 hover:text-white hover:border-slate-800 transition-all">
                                        <lucide-icon [img]="icons.Eye" class="w-3.5 h-3.5"></lucide-icon>
                                        Detalhes
                                    </button>
                                </div>
                            </div>

                            <!-- Progress bar -->
                            <div>
                                <div class="flex justify-between text-[11px] font-semibold text-slate-400 mb-1">
                                    <span>{{ runStepsSummary(run) }}</span>
                                    <span class="flex items-center gap-2">
                                        <span *ngIf="runFailures(run) > 0" class="text-red-500 font-bold">{{
                                            runFailures(run) }} {{ runFailures(run) === 1 ? 'falha' : 'falhas' }}</span>
                                        {{ runProgress(run) }}%
                                    </span>
                                </div>
                                <div class="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
                                    <div class="h-full rounded-full transition-all duration-500 ease-out"
                                        [ngClass]="run.status === 'ERROR' ? 'bg-gradient-to-r from-red-400 to-red-500' : run.status === 'RUNNING' ? 'bg-gradient-to-r from-indigo-400 to-indigo-500' : 'bg-gradient-to-r from-emerald-400 to-teal-500'"
                                        [style.width.%]="runProgress(run)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    </ng-container>

    <!-- ================= DETALHE ================= -->
    <ng-container *ngIf="detailRun() as run">

        <header class="bg-white border-b border-slate-200 px-8 py-5 flex items-center justify-between shrink-0">
            <div class="flex items-center gap-4">
                <button (click)="backToList()"
                    class="w-9 h-9 rounded-xl border border-slate-200 flex items-center justify-center text-slate-500 hover:bg-slate-100 transition-colors"
                    title="Voltar">
                    <lucide-icon [img]="icons.ArrowLeft" class="w-4 h-4"></lucide-icon>
                </button>
                <div>
                    <div class="flex items-center gap-3">
                        <h1 class="text-lg font-bold text-slate-800 font-mono">{{ run.id }}</h1>
                        <span class="text-[11px] px-2.5 py-0.5 rounded-full border font-semibold"
                            [ngClass]="runBadgeClass(run.status)">
                            {{ runStatusLabel(run.status) }}
                        </span>
                        <span *ngIf="run.status === 'RUNNING'"
                            class="text-[10px] font-bold text-white bg-red-500 px-2 py-0.5 rounded-full uppercase tracking-wider animate-pulse">ao
                            vivo</span>
                    </div>
                    <p class="text-xs text-slate-500 mt-0.5">
                        {{ run.startedAt | date:'dd/MM/yyyy HH:mm:ss' }} · disparada por {{ run.triggeredBy }}
                    </p>
                </div>
            </div>
            <div class="text-right">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Progresso</p>
                <p class="text-2xl font-black text-slate-800">{{ runProgress(run) }}%</p>
            </div>
        </header>

        <div class="flex-1 overflow-y-auto p-8">
            <div class="max-w-4xl mx-auto flex flex-col gap-3">

                <!-- SANFONA POR ROTA -->
                <div *ngFor="let step of detailSteps(); trackBy: trackStep.bind(this)"
                    class="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">

                    <!-- Linha da rota -->
                    <div (click)="toggleStep(step)"
                        class="w-full flex items-center gap-4 px-6 py-4 hover:bg-slate-50/70 transition-colors text-left"
                        [class.bg-indigo-50/40]="step.status === 'RUNNING'">
                        <lucide-icon [img]="stepIcon(step.status)" class="w-5 h-5 shrink-0"
                            [ngClass]="stepIconClass(step.status)"></lucide-icon>

                        <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-2">
                                <p class="text-sm font-semibold text-slate-800">{{ step.label }}</p>
                                <span class="text-[10px] font-bold text-slate-400 bg-slate-100 rounded px-1.5 py-0.5">{{
                                    step.group }}</span>
                            </div>
                            <!-- mini progress -->
                            <div class="flex items-center gap-3 mt-1.5">
                                <div class="h-1.5 w-40 bg-slate-100 rounded-full overflow-hidden">
                                    <div class="h-full rounded-full transition-all duration-500"
                                        [ngClass]="step.status === 'ERROR' ? 'bg-red-400' : step.status === 'FETCH_ERROR' ? 'bg-orange-400' : step.status === 'RUNNING' ? 'bg-indigo-400' : 'bg-emerald-400'"
                                        [style.width.%]="stepPercent(step)"></div>
                                </div>
                                <span class="text-[11px] font-bold text-slate-500">{{ stepPercent(step) }}%</span>
                                <span *ngIf="step.totalProcessed > 0" class="text-[11px] text-slate-400">
                                    {{ step.totalSuccess }}/{{ step.totalProcessed }} registros · {{
                                    formatDuration(step.processingTimeMs) }}
                                </span>
                                <!-- Status label quando não há dados de progresso -->
                                <span *ngIf="step.totalProcessed === 0"
                                    class="text-[10px] font-semibold italic"
                                    [ngClass]="step.status === 'ERROR' ? 'text-red-500' : step.status === 'FETCH_ERROR' ? 'text-orange-500' : step.status === 'RUNNING' ? 'text-indigo-500' : step.status === 'SUCCESS' ? 'text-emerald-500' : 'text-slate-400'">
                                    {{ step.statusLabel }}
                                </span>
                            </div>
                        </div>

                        <!-- Botão Reprocessar (sempre visível no cabeçalho quando ERROR) -->
                        <button *ngIf="step.status === 'ERROR' && canTrigger()"
                            (click)="retry(step, $event)"
                            [disabled]="retryingJobUuid() === step.uuid || !step.uuid"
                            class="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[11px] font-bold bg-red-600 text-white hover:bg-red-700 transition-all shadow-sm active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 shrink-0">
                            @if (retryingJobUuid() === step.uuid) {
                                <lucide-icon [img]="icons.Loader" class="w-3.5 h-3.5 animate-spin"></lucide-icon>
                                Reprocessando...
                            } @else {
                                <lucide-icon [img]="icons.RotateCcw" class="w-3.5 h-3.5"></lucide-icon>
                                Reprocessar
                            }
                        </button>

                        <lucide-icon [img]="isStepExpanded(step.key) ? icons.ChevronDown : icons.ChevronRight"
                            class="w-4 h-4 text-slate-300 shrink-0"></lucide-icon>
                    </div>

                    <!-- Conteúdo expandido: lista de itens -->
                    <div *ngIf="isStepExpanded(step.key)"
                        class="border-t border-slate-100 bg-slate-50/60 px-6 py-5 flex flex-col gap-4">

                        <!-- Sumário de registros -->
                        <div *ngIf="step.totalProcessed > 0" class="flex items-center gap-2 flex-wrap">
                            <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-slate-100 text-slate-600 border border-slate-200">
                                {{ step.totalProcessed }} registros
                            </span>
                            <span *ngIf="step.totalSuccess > 0"
                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200">
                                <lucide-icon [img]="icons.CheckCircle" class="w-2.5 h-2.5"></lucide-icon>
                                {{ step.totalSuccess }} sucesso(s)
                            </span>
                            <span *ngIf="step.totalFailures > 0"
                                [class]="'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ' +
                                    (step.status === 'FETCH_ERROR' ? 'bg-orange-50 text-orange-700 border-orange-200' : 'bg-red-50 text-red-700 border-red-200')">
                                <lucide-icon [img]="step.status === 'FETCH_ERROR' ? icons.AlertTriangle : icons.XCircle" class="w-2.5 h-2.5"></lucide-icon>
                                {{ step.totalFailures }} {{ step.status === 'FETCH_ERROR' ? 'inválido(s)' : 'erro(s)' }}
                            </span>
                        </div>

                        <!-- Mensagem do job (info, aviso ou erro — qualquer status) -->
                        <div *ngIf="step.message"
                            class="flex items-start gap-2 p-3 rounded-xl border"
                            [ngClass]="(step.status === 'ERROR' || step.status === 'FETCH_ERROR') ? 'bg-red-50 border-red-200' : 'bg-slate-50 border-slate-200'">
                            <lucide-icon
                                [img]="(step.status === 'ERROR' || step.status === 'FETCH_ERROR') ? icons.AlertTriangle : icons.Info"
                                [class]="'w-3.5 h-3.5 shrink-0 mt-0.5 ' + ((step.status === 'ERROR' || step.status === 'FETCH_ERROR') ? 'text-red-500' : 'text-slate-400')">
                            </lucide-icon>
                            <p [class]="'text-[11px] leading-relaxed whitespace-pre-wrap ' + ((step.status === 'ERROR' || step.status === 'FETCH_ERROR') ? 'text-red-700' : 'text-slate-600')">
                                {{ step.message }}
                            </p>
                        </div>

                        <!-- Ainda não executada (só mostra para status PENDING, não ERROR) -->
                        <div *ngIf="step.totalProcessed === 0 && step.status !== 'RUNNING' && step.status !== 'ERROR' && step.status !== 'FETCH_ERROR'"
                            class="flex items-center justify-center gap-2 py-6">
                            <lucide-icon [img]="icons.Clock" class="w-4 h-4 text-slate-300"></lucide-icon>
                            <p class="text-xs text-slate-400 italic">Rota ainda não executada.</p>
                        </div>

                        <!-- Em execução -->
                        <div *ngIf="step.status === 'RUNNING'"
                            class="flex items-center justify-center gap-2 py-6">
                            <lucide-icon [img]="icons.Loader" class="w-4 h-4 text-indigo-500 animate-spin"></lucide-icon>
                            <p class="text-xs text-indigo-600 font-semibold">Processando registros...</p>
                        </div>

                        <!-- Loading itens do job -->
                        <div *ngIf="step.uuid && isJobItemsLoading(step.uuid)"
                            class="flex items-center justify-center gap-2 py-6">
                            <lucide-icon [img]="icons.Loader" class="w-4 h-4 text-slate-400 animate-spin"></lucide-icon>
                            <p class="text-xs text-slate-400">Carregando itens...</p>
                        </div>

                        <!-- Erro ao carregar itens do job -->
                        <div *ngIf="step.uuid && getJobItemsError(step.uuid) && !isJobItemsLoading(step.uuid)"
                            class="flex items-center gap-2 p-3 rounded-xl bg-red-50 border border-red-200">
                            <lucide-icon [img]="icons.AlertTriangle" class="w-3.5 h-3.5 text-red-500 shrink-0"></lucide-icon>
                            <p class="text-[11px] text-red-700 flex-1">{{ getJobItemsError(step.uuid) }}</p>
                            <button (click)="reloadJobItems(step.uuid, $event)"
                                class="flex items-center gap-1 text-[10px] font-bold text-red-600 hover:text-red-800 border border-red-200 px-2 py-1 rounded-lg hover:bg-red-100 transition-colors shrink-0">
                                <lucide-icon [img]="icons.RefreshCw" class="w-3 h-3"></lucide-icon>
                                Tentar novamente
                            </button>
                        </div>

                        <!-- Itens carregados da API -->
                        <ng-container *ngIf="step.uuid && !isJobItemsLoading(step.uuid) && !getJobItemsError(step.uuid)">

                            <!-- Cabeçalho com botão de atualizar -->
                            <div *ngIf="getJobItems(step.uuid).length > 0 || step.status !== 'SUCCESS'"
                                class="flex items-center justify-between">
                                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                                    Itens com erro
                                </span>
                                <button (click)="reloadJobItems(step.uuid, $event)"
                                    class="flex items-center gap-1 text-[10px] font-semibold text-slate-500 hover:text-indigo-600 border border-slate-200 hover:border-indigo-300 px-2 py-1 rounded-lg hover:bg-indigo-50 transition-colors"
                                    title="Atualizar lista">
                                    <lucide-icon [img]="icons.RefreshCw" class="w-3 h-3"></lucide-icon>
                                    Atualizar
                                </button>
                            </div>

                            <!-- Sem itens com erro -->
                            <div *ngIf="getJobItems(step.uuid).length === 0 && step.status === 'SUCCESS'"
                                class="flex items-center justify-center gap-2 py-4">
                                <lucide-icon [img]="icons.CheckCircle" class="w-4 h-4 text-emerald-500"></lucide-icon>
                                <p class="text-xs text-emerald-600 font-semibold">Todos os registros foram processados com sucesso.</p>
                            </div>

                            <!-- Lista de itens -->
                            <div *ngIf="getJobItems(step.uuid).length > 0" class="flex flex-col gap-2">
                                <div class="rounded-xl border border-red-100 overflow-hidden">
                                    <div *ngFor="let item of getPagedJobItems(step.uuid); trackBy: trackJobItem.bind(this)"
                                        class="flex items-center gap-3 px-4 py-2.5 border-b border-red-50 last:border-0 bg-white hover:bg-red-50/30 transition-colors">
                                        <!-- Status -->
                                        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-bold bg-red-50 text-red-700 border border-red-200 shrink-0">
                                            <lucide-icon [img]="icons.XCircle" class="w-2.5 h-2.5"></lucide-icon>
                                            Erro
                                        </span>
                                        <!-- Código externo -->
                                        <span class="font-mono font-bold text-slate-700 text-[11px] shrink-0 max-w-[160px] truncate" [title]="item.externalCode">{{ item.externalCode }}</span>
                                        <!-- Descrição -->
                                        <span class="text-[11px] text-slate-500 shrink-0 w-40 truncate hidden md:block" [title]="item.description">{{ item.description }}</span>
                                        <!-- Mensagem de erro -->
                                        <span class="text-[11px] text-red-600 flex-1 leading-relaxed">{{ item.errorMessage }}</span>
                                    </div>
                                </div>

                                <!-- Paginação -->
                                <div *ngIf="getJobItemsTotalPages(step.uuid) > 1"
                                    class="flex items-center justify-between text-[10px] text-slate-500 pt-1">
                                    <span>Exibindo {{ getPagedJobItems(step.uuid).length }} de {{ getJobItems(step.uuid).length }} item(ns)</span>
                                    <div class="flex items-center gap-1">
                                        <button (click)="prevJobItemsPage(step.uuid, $event)"
                                            [disabled]="getJobItemsPage(step.uuid) === 0"
                                            class="px-2.5 py-1 rounded-lg border border-slate-200 font-semibold text-slate-600 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                                            ‹
                                        </button>
                                        <span class="px-2 font-semibold text-slate-600">
                                            {{ getJobItemsPage(step.uuid) + 1 }} / {{ getJobItemsTotalPages(step.uuid) }}
                                        </span>
                                        <button (click)="nextJobItemsPage(step.uuid, $event)"
                                            [disabled]="getJobItemsPage(step.uuid) >= getJobItemsTotalPages(step.uuid) - 1"
                                            class="px-2.5 py-1 rounded-lg border border-slate-200 font-semibold text-slate-600 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                                            ›
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </ng-container>

                        <!-- Botão Reprocessar (rodapé da seção expandida) -->
                        <!-- ERROR: só permite retry quando a run terminou. FETCH_ERROR: permite mesmo com run em andamento (o job já encerrou) -->
                        <div *ngIf="((step.status === 'ERROR' && run.status !== 'RUNNING') || step.status === 'FETCH_ERROR') && canTrigger()"
                            class="flex justify-end pt-2 border-t border-slate-100">
                            <button (click)="retry(step, $event)"
                                [disabled]="retryingJobUuid() === step.uuid || !step.uuid"
                                class="flex items-center gap-1.5 px-4 py-1.5 rounded-xl text-[11px] font-bold bg-red-600 text-white hover:bg-red-700 transition-all shadow-sm active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100">
                                @if (retryingJobUuid() === step.uuid) {
                                    <lucide-icon [img]="icons.Loader" class="w-3.5 h-3.5 animate-spin"></lucide-icon>
                                    Reprocessando...
                                } @else {
                                    <lucide-icon [img]="icons.RotateCcw" class="w-3.5 h-3.5"></lucide-icon>
                                    Reprocessar
                                }
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </ng-container>

    <!-- ================= MODAL: NOVA INTEGRAÇÃO ================= -->
    <div *ngIf="showModal()" class="fixed inset-0 z-[60] flex items-center justify-center p-4">
        <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" (click)="closeModal()"></div>

        <div
            class="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden animate-fade-in">
            <!-- Modal header -->
            <div class="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
                <div class="flex items-center gap-3">
                    <div
                        class="w-9 h-9 rounded-xl bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center text-white">
                        <lucide-icon [img]="icons.Database" class="w-4 h-4"></lucide-icon>
                    </div>
                    <div>
                        <h3 class="text-sm font-bold text-slate-800">Nova Integração</h3>
                        <p class="text-[11px] text-slate-400">Selecione o que deseja enviar ao Allora</p>
                    </div>
                </div>
                <button (click)="closeModal()" class="text-slate-300 hover:text-slate-500 transition-colors">
                    <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
                </button>
            </div>

            <!-- Modal body -->
            <div class="flex-1 overflow-y-auto px-6 py-4">

                <!-- Estado: carregando job types -->
                <div *ngIf="jobTypesLoading()"
                    class="flex flex-col items-center justify-center py-10 gap-3">
                    <lucide-icon [img]="icons.Loader" class="w-6 h-6 text-orange-500 animate-spin"></lucide-icon>
                    <p class="text-xs text-slate-500 font-medium">Carregando tipos de integração...</p>
                </div>

                <!-- Estado: erro ao carregar job types -->
                <div *ngIf="jobTypesError() && !jobTypesLoading()"
                    class="flex flex-col items-center justify-center py-10 gap-3">
                    <div class="w-10 h-10 rounded-full bg-red-50 border border-red-200 flex items-center justify-center">
                        <lucide-icon [img]="icons.AlertTriangle" class="w-5 h-5 text-red-500"></lucide-icon>
                    </div>
                    <p class="text-xs text-slate-600">{{ jobTypesError() }}</p>
                    <button (click)="service.reloadJobTypes()"
                        class="flex items-center gap-1.5 text-xs font-bold text-slate-500 border border-slate-200 hover:bg-slate-100 px-3 py-1.5 rounded-lg transition-colors">
                        <lucide-icon [img]="icons.RefreshCw" class="w-3.5 h-3.5"></lucide-icon>
                        Tentar novamente
                    </button>
                </div>

                <!-- Lista de job types agrupada por categoria -->
                <ng-container *ngIf="!jobTypesLoading() && !jobTypesError() && service.jobTypes().length > 0">
                    <button (click)="toggleAllJobTypes()"
                        class="text-[11px] font-bold text-indigo-600 hover:text-indigo-800 mb-3">
                        {{ selectedJobTypes().size === service.jobTypes().length ? 'Desmarcar todos' : 'Selecionar todos' }}
                    </button>

                    <div *ngFor="let group of jobTypeGroups()" class="mb-4">
                        <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">{{ group.name }}</p>
                        <div class="flex flex-col gap-1.5">
                            <label *ngFor="let jt of group.items; trackBy: trackJobType.bind(this)"
                                class="flex items-center gap-3 px-3 py-2.5 rounded-xl border cursor-pointer transition-all"
                                [ngClass]="isJobTypeSelected('' + jt.jobType) ? 'border-indigo-300 bg-indigo-50/60' : 'border-slate-200 hover:bg-slate-50'">
                                <input type="checkbox"
                                    [checked]="isJobTypeSelected('' + jt.jobType)"
                                    (change)="toggleJobType('' + jt.jobType)"
                                    class="w-4 h-4 rounded accent-indigo-600" />
                                <p class="text-xs font-semibold text-slate-700 flex-1">{{ jt.displayName }}</p>
                            </label>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Modal footer -->
            <div class="px-6 py-4 border-t border-slate-100 flex flex-col gap-2 bg-slate-50/60">
                <!-- Erro de criação -->
                <div *ngIf="syncError()"
                    class="flex items-start gap-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200">
                    <lucide-icon [img]="icons.AlertTriangle" class="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5"></lucide-icon>
                    <p class="text-[11px] text-red-700 leading-relaxed">{{ syncError() }}</p>
                </div>

                <div class="flex items-center justify-between">
                    <p class="text-[11px] text-slate-400">{{ selectedJobTypes().size }} selecionado(s)</p>
                    <div class="flex items-center gap-2">
                        <button (click)="closeModal()" [disabled]="syncing()"
                            class="px-4 py-2 rounded-xl text-xs font-bold text-slate-500 border border-slate-200 hover:bg-slate-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
                            Cancelar
                        </button>
                        <button (click)="confirmIntegration()"
                            [disabled]="selectedJobTypes().size === 0 || jobTypesLoading() || syncing()"
                            class="flex items-center gap-2 px-5 py-2 rounded-xl text-xs font-bold text-white bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 shadow-lg shadow-orange-500/25 transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:active:scale-100">
                            @if (syncing()) {
                                <lucide-icon [img]="icons.Loader" class="w-3.5 h-3.5 animate-spin"></lucide-icon>
                                Enviando...
                            } @else {
                                <lucide-icon [img]="icons.Zap" class="w-3.5 h-3.5"></lucide-icon>
                                INTEGRAR
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ===================== TOAST ===================== -->
    @if (toast(); as t) {
    <div class="fixed bottom-4 right-4 z-[200] animate-slide-up">
        <div [class]="'flex items-center gap-2 px-4 py-3 rounded-xl shadow-2xl border text-sm font-medium ' +
            (t.type === 'success' ? 'bg-emerald-50 text-emerald-800 border-emerald-200' : 'bg-red-50 text-red-800 border-red-200')">
            <lucide-icon [img]="t.type === 'success' ? icons.CheckCircle : icons.AlertOctagon"
                [class]="'w-4 h-4 shrink-0 ' + (t.type === 'success' ? 'text-emerald-600' : 'text-red-600')"></lucide-icon>
            {{ t.message }}
        </div>
    </div>
    }

</div>